import { generateRequest } from '.';
import Notifications from '../constants/notifications';

export const Action = {
  Pay: {
    RequestSYWInfo: 'RequestSYWInfo',
    RequestSYWInfoComplete: 'RequestSYWInfoComplete',
    RequestSYWInfoFailed: 'RequestSYWInfoFailed',
  },
};

export const requestSYWInfo = email => generateRequest({
  method: 'POST',
  endpoint: '/assets-v2/api/marketing/notification',
  body: {
    email,
    key: Notifications.SYWInfo,
  },
  types: [
    Action.Pay.RequestSYWInfo,
    Action.Pay.RequestSYWInfoComplete,
    Action.Pay.RequestSYWInfoFailed,
  ],
});
